import React, { createContext, useState, useEffect, useContext, ReactNode } from 'react';
import api from '../../api/api';

interface MastersContextType {
  masters: any;
  loading: boolean;
  error: Error | null;
}

// Create the context
const MastersContext = createContext<MastersContextType | undefined>(undefined);

interface MastersProviderProps {
  children: ReactNode;
}

// Provider component
export const MastersProvider: React.FC<MastersProviderProps> = ({ children }) => {
  const [masters, setMasters] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchMasters = async () => {
      try {
        const response = await api.get('/masters');
        const mastersData = response.data?.data || response.data;
        setMasters(mastersData);
        setError(null);
      } catch (err: any) {
        setError(err.response?.data?.message || err.message || new Error('Failed to fetch masters'));
      } finally {
        setLoading(false);
      }
    };

    fetchMasters();
  }, []);

  return (
    <MastersContext.Provider value={{ masters, loading, error }}>
      {children}
    </MastersContext.Provider>
  );
};

// Custom hook for using the Masters context
export const useMasters = (): MastersContextType => {
  const context = useContext(MastersContext);
  if (context === undefined) {
    throw new Error('useMasters must be used within a MastersProvider');
  }
  return context;
};
